// src/pages/team/TeamDetailPage.tsx
// Legacy route kept resolvable for old links/bookmarks. Everything the old
// detail page did now lives on the workspace hub (/teams/:id): overview,
// join request, settings, and the Branding page for avatar/banner. This
// route just sends people there.

import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const TeamDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  useEffect(() => {
    navigate(id ? `/teams/${id}` : '/teams', { replace: true });
  }, [navigate, id]);
  return null;
};

export default TeamDetailPage;
